import { forwardRef, useImperativeHandle, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export type AnnotationsOverlayHandle = {
  zoomToElement: (element: HTMLElement | string, scale: number, duration: number) => void;
  resetTransform: () => void;
};

export type AnnotationsOverlayProps = {
  children: React.ReactNode;
};

const AnnotationsOverlay = forwardRef<AnnotationsOverlayHandle, AnnotationsOverlayProps>(({ children }, ref) => {
  const transformRef = useRef<AnnotationsOverlayHandle>({
    zoomToElement: () => {},
    resetTransform: () => {},
  });

  useImperativeHandle(
    ref,
    () => ({
      zoomToElement: (element: HTMLElement | string, scale: number, duration: number) => {
        transformRef.current?.zoomToElement(element, scale, duration);
      },
      resetTransform: () => {
        transformRef.current?.resetTransform();
      },
    }),
    [],
  );

  return (
    <TransformWrapper
      centerOnInit={true}
      initialScale={1}
      maxScale={4}
      minScale={1}
      zoomAnimation={{ animationType: "easeOutQuart" }}
    >
      {(transformProps) => {
        transformRef.current = transformProps;
        return (
          <TransformComponent
            contentStyle={{
              height: "100%",
              width: "100%",
            }}
            wrapperStyle={{
              height: "100%",
              width: "100%",
            }}
          >
            <div
              className="h-full w-full"
              onDoubleClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                transformRef.current?.resetTransform();
              }}
            >
              {children}
            </div>
          </TransformComponent>
        );
      }}
    </TransformWrapper>
  );
});

export default AnnotationsOverlay;
